export default function Cross_Validation() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Cross_Validation</h1>
      <p>Content for Cross_Validation goes here.</p>
    </div>
  );
}